module.exports = __webpack_public_path__ + "assets/c1a99289a303c1632437f965efbab0c2.mp3";